// extracted by mini-css-extract-plugin
module.exports = {"message":"AfterpayMessage_message__vpBIw"};